import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Badge } from '@/components/ui/badge';
import { popModal } from '@/redux/modals/actions';
import { isModalOpen } from '@/redux/modals/selectors';

// Only ever mounted by the caller when the node is the brain's starting
// node, so its hooks (esp. the isModalOpen subscription) don't run for
// every other node on the canvas.
export const StartingNodeBadge = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { slug, brainId } = useParams();
  const modalOpen = useSelector(isModalOpen);

  const handleClick = () => {
    // Close the dialog preview modal if we're inside one before navigating.
    if (modalOpen) {
      dispatch(popModal());
    }
    navigate(`/${slug}/ai-agents/${brainId}/settings#conversation-start`);
  };

  return (
    <InfoTooltip
      content={t('ai_agents.conversation_start.node_badge_tooltip')}
      side="top"
      showArrow
    >
      <Badge
        asChild
        type="outline"
        flavour="informational"
        className="absolute top-1/2 right-full z-1 mr-2 -translate-y-1/2 bg-background"
      >
        <button type="button" onClick={handleClick}>
          {t('ai_agents.conversation_start.overview_label')}
        </button>
      </Badge>
    </InfoTooltip>
  );
};
